import React from 'react';
import styled from '@emotion/styled';

import { FieldRadioButtonLayout } from 'components/shared/Fields/FieldRadioButton/FieldRadioButton';
import { NotificationStatus } from 'shared/types';
import { NotificationFilter, setStatusFilter } from 'store/notificationsList';
import { useAppDispatch, useAppSelector } from 'store/shared/hooks';
import { theme } from 'theme';
import { useTypedIntl } from './locale/messages';

const Container = styled.div`
  border-bottom: 1px solid ${theme.colors.mineShaftLightest};
`;

export function NotificationsFilters(): React.ReactElement {
  const intl = useTypedIntl();
  const dispatch = useAppDispatch();
  const notificationsListData = useAppSelector(state => state.notificationsList);
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setStatusFilter(e.target.value as NotificationFilter));
  };
  const radioOptions = [
    {
      label: intl.formatMessage({
        id: 'Notifications.Filters.Status.OPEN',
      }),
      value: NotificationStatus.OPEN,
    },
    {
      label: intl.formatMessage({
        id: 'Notifications.Filters.Status.RESOLVED',
      }),
      value: NotificationStatus.RESOLVED,
    },
    {
      label: intl.formatMessage({
        id: 'Notifications.Filters.Status.ALL',
      }),
      value: 'ALL',
    },
  ];

  return (
    <Container>
      <FieldRadioButtonLayout
        onChange={handleRadioChange}
        name="notifications-filters"
        options={radioOptions}
        value={notificationsListData.statusFilter}
        dataCy="notifications-header-filters"
        hideContainerBorder
        radioButtonBorderColor={theme.colors.mineShaftLightest}
        disableRounding
      />
    </Container>
  );
}
